import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import Skeleton from '@atlaskit/skeleton';

interface SkeletonItem {
  width: string;
  height: string;
  testId: string;
  marginBottom?: string;
  marginTop?: string;
  paddingLeft?: string;
}

export const SkeletonLoader = () => {
  const skeletonData: SkeletonItem[] = [
    // Title
    { width: '140px', height: '20px', testId: 'skeleton-title', marginBottom: token('space.200') },

    // Summary text lines
    { width: '100%', height: '16px', testId: 'skeleton-line-1', marginBottom: '8px' },
    { width: '100%', height: '16px', testId: 'skeleton-line-2', marginBottom: '8px' },
    { width: '100%', height: '16px', testId: 'skeleton-line-3', marginBottom: '8px' },
    { width: '75%', height: '16px', testId: 'skeleton-line-4', marginBottom: token('space.200') },

    // Key Points title
    {
      width: '80px',
      height: '16px',
      testId: 'skeleton-keypoints-title',
      marginTop: token('space.200'),
      marginBottom: token('space.150'),
    },

    // Key Points list items
    {
      width: '90%',
      height: '14px',
      testId: 'skeleton-keypoint-1',
      marginBottom: '6px',
      paddingLeft: token('space.200'),
    },
    {
      width: '85%',
      height: '14px',
      testId: 'skeleton-keypoint-2',
      marginBottom: '6px',
      paddingLeft: token('space.200'),
    },
    {
      width: '92%',
      height: '14px',
      testId: 'skeleton-keypoint-3',
      marginBottom: token('space.200'),
      paddingLeft: token('space.200'),
    },

    // Sentiment
    { width: '120px', height: '14px', testId: 'skeleton-sentiment', marginTop: token('space.200') },
  ];

  return (
    <div css={contentStyles}>
      {skeletonData.map((item, index) => (
        <div
          key={index}
          style={{
            marginBottom: item.marginBottom,
            marginTop: item.marginTop,
            paddingLeft: item.paddingLeft,
          }}
        >
          <Skeleton
            width={item.width}
            height={item.height}
            isShimmering={true}
            color="white"
            ShimmeringEndColor="rgba(255, 255, 255, 0.7)"
            testId={item.testId}
          />
        </div>
      ))}
    </div>
  );
};

const contentStyles = css({
  paddingInlineStart: token('space.200'),
  paddingInlineEnd: token('space.200'),
  paddingBlockStart: token('space.200'),
  paddingBlockEnd: token('space.200'),
  width: '400px',
  height: '300px',
  backgroundColor: token('color.background.discovery.bold'),
});
